import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dialog } from 'primereact/dialog';
// import AddEditRoles from './AddEditRoles';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { InputSwitch } from 'primereact/inputswitch';
import { useDispatch } from 'react-redux';
import { handlePutRequest } from '../../service/PutTemplate';
import ActiveInactiveDialog from '../../components/ActiveInactiveDialog';

const Roles = () => {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allRoles, setAllRoles] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let data = {
            isActive: switchData?.isActive ? false : true
        };

        const response = await dispatch(handlePutRequest(data, endPoints?.updateRole, false, true));

        if (response?.status === 200) {
            getRoleList();
        }

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <InputSwitch
                        tooltip="Status"
                        tooltipOptions={{ position: 'top' }}
                        checked={rowData.isActive}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />

                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    <Button
                        tooltip="View"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const getRoleList = async () => {
        const response = await handleGetRequest(endPoints.getallRoles, false);
        if (response) {
            setAllRoles(response);
        }
    };

    useEffect(() => {
        getRoleList();
    }, []);

    const onHide = () => {
        setShowAddDialog(false);
        getRoleList();
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Biller List</h3>
                <div className="flex gap-2">
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />
                </div>
            </div>
            <Dialog header={<div>{editable ? 'Edit Role' : viewable ? 'View Role' : 'Add Role'}</div>} visible={showAddDialog} onHide={onHide} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                {/* <AddEditRoles rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} /> */}
            </Dialog>

            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allRoles}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="billerName" header="Biller Name" />
                <Column field="createdDate" header="Created Date" body={(rowData) => (rowData.createdDate ? new Date(rowData.createdDate).toLocaleDateString() : '')} />
                <Column field="transactionId" header="Transaction Id" />
                <Column field="amount" header="Amount" />
                <Column
                    header="Consumer Number"
                    // body={actionBodyTemplate}
                    className="Table__ActionHeading__CentredAlign"
                />
            </DataTable>
        </div>
    );
};

export default Roles;
